export const NEW_PROJECTION_STATE = "NEW_PROJECTION_STATE";
export const UPDATING_PROJECTION_STATE = "UPDATING_PROJECTION_STATE";
export const UPDATED_PROJECTION_STATE = "UPDATED_PROJECTION_STATE";
export const NEW_ACTUALS_SINCE_LAST_UPDATED_PROJECTION_STATE =
  "NEW_ACTUALS_SINCE_LAST_UPDATED_PROJECTION_STATE";
